import { useUpdateRealEstateAgencyMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useUpdateRealEstateAgency = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useUpdateRealEstateAgencyMutation(headerWithAuth, options);

  return mutate;
};

export {
  useUpdateRealEstateAgency,
};
